import { CLOSE_WEBSOCKET_CONNECTION, CREATE_WEBSOCKET_CONNECTION } from "../action/grochatWebsocketAction";

const grochatWebsocketState = {
    websocket: null
}

const grochatWebsocketReducer = (state = grochatWebsocketState, action) => {
    switch (action.type) {
        case CREATE_WEBSOCKET_CONNECTION:
            return {
                ...state,
                websocket: action.payload,
            };
        case CLOSE_WEBSOCKET_CONNECTION:
            return {
                ...state,
                websocket: null,
            };

        default:
            return state;
    }
}

export default grochatWebsocketReducer;